import PageLayout from '../../Containers/PageLayout';
import CreateDepartment from '../Department/createDepartment';
import AddContactsProducts from './components/AddContactsProducts';
import CreateProduction from './components/CreateProduction';
import ProductsList from './components/ProductionsList';

interface Props {
  page: string;
}

const ProductManagement = (props: Props) => {
  const { page } = props;

  return (
    <PageLayout>
      <div>
        {page === 'ProductMamagement' ? (
          <ProductsList />
        ) : ['CreateProduction', 'UpdateProduction'].includes(page) ? (
          <CreateProduction />
        ) : page === 'AddContactProduct' ? (
          <AddContactsProducts />
        ) : page === 'departments' ? (
          <CreateDepartment />
        ) : (
          <p>null</p>
        )}
      </div>
    </PageLayout>
  );
};

export default ProductManagement;
